import React from 'react';
import {ScrollView, StyleSheet, Text, View} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import {orangeLighter, rose} from '/theme/color/secondary.color';

import Gutter from '../Gutter';

const storyStyle = StyleSheet.create({
  gutterContainer: {
    backgroundColor: rose,
  },
  exampleView: {
    backgroundColor: orangeLighter,
    padding: 40,
  },
});

storiesOf('layout', module).add('Gutter', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView expand={true}>
        <Heading level={1}>Gutter</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>Gutter</Code> component is used to render content with added
          spacing on both side.
        </Text>
        <Spacer size={16} />
        <View style={storyStyle.gutterContainer}>
          <Gutter>
            <View style={storyStyle.exampleView}>
              <Text>Content</Text>
            </View>
          </Gutter>
        </View>
        <Spacer size={6} />
        <Code>{'<Gutter>'}</Code>
        <Code>{'  ...'}</Code>
        <Code>{'</Gutter>'}</Code>
        <Spacer size={16} />
        <Text>
          The default spacing is <Code>20px</Code> and it can be adjusted by
          passing in a <Code>size</Code> props.
        </Text>
        <Spacer size={16} />
        <View style={storyStyle.gutterContainer}>
          <Gutter size={40}>
            <View style={storyStyle.exampleView}>
              <Text>Content</Text>
            </View>
          </Gutter>
        </View>
        <Spacer size={6} />
        <Code>{'<Gutter size={40}>'}</Code>
        <Code>{'  ...'}</Code>
        <Code>{'</Gutter>'}</Code>
      </FlexView>
    </Spacing>
  </ScrollView>
));
